import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  CardContent,
  Card,
  CardMedia,
  Typography,
  Divider,
  IconButton,
  Grid,
  Button,
  Skeleton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  useMediaQuery,
  Container,
  Paper,
  styled,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import autodukan_logo from "../../assets/images/autoducan_logo.png";
import { getRecentllyViewed } from "../../services/user";
import useTheme from "@mui/system/useTheme";
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import parts from "../../assets/images/parts.png";
import availability from "../../assets/images/availability.png";
import rates from "../../assets/images/rates.png";
import delivery from "../../assets/images/delivery.png";
import mobile_design from "../../assets/images/mobile_design.jpg";
import mobile_design2 from "../../assets/images/mobile_design2.jpg";
import google_playstore from "../../assets/images/google_playstore.png";
import Recentlyviwed from "../../components/commenMUI/Recentlyviwed";
import CloseIcon from "@mui/icons-material/Close";
import { useSelectedCar } from "../../utils/SelectedCar";
import {
  getCarBrands,
} from "../../services/home";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import benifits4 from "../../assets/images/benifits_4.png";

const BrandCard = ({ item, onClick, isLoading }) => {
  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          border: "2px solid #E0E0E0",
          backgroundColor: "#FFFFFF",
          borderRadius: "10px",
          justifyContent: "center",
          height: "120px",
          p: 2
        }}
      >
        <Skeleton variant="rectangular" width={100} height={100} />
      </Box>
    );
  }

  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        border: "2px solid #E0E0E0",
        backgroundColor: "#FFFFFF",
        borderRadius: "10px",
        justifyContent: "center",
        height: "120px",
        cursor: "pointer",
        transition: "transform 0.2s, box-shadow 0.2s",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          borderColor: "rgba(255, 102, 51, 0.5)"
        }
      }}
    >
      <Box sx={{ p: 2 }}>
        <img
          loading="lazy"
          src={item.icon ? item.icon : autodukan_logo}
          alt={item.name}
          style={{
            width: "100px",
            height: "100px",
            objectFit: "contain",
          }}
        />
      </Box>
    </Box>
  );
};

const BrandsSection = ({ title, brands, onViewAll, handleClick, sliderRef, isLoading, brand_count }) => {
  const theme = useTheme();

  return (
    <Box sx={{ mb: { xs: 6, md: 8 } }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 4
        }}
      >
        <Box>
          {isLoading ? (
            <Skeleton width={200} height={40} />
          ) : (
            <h2
              className="title_name1"
              style={{
                margin: 0,
                textTransform: "uppercase",
                fontWeight: 500,
                lineHeight: "30px",
                fontFamily: "'Bebas Neue', sans-serif"
              }}
            >
              {title}
            </h2>
          )}
        </Box>
        <Box>
          {isLoading ? (
            <Skeleton width={120} height={40} />
          ) : (
            <Link to={onViewAll}>
              <Button
                variant="contained"
                endIcon={<ArrowForwardOutlinedIcon style={{ fontSize: '15px' }} />}
                sx={{
                  backgroundColor: "rgba(255, 102, 51, 1)",
                  fontFamily: "'Barlow', sans-serif",
                  textTransform: "none",
                  borderRadius: "5px",
                  width: { lg: "129px", xs: "110px", sm: "121px", md: "121px" },
                  fontSize: { lg: "19px", xs: "17px", sm: "19px", md: "19px" },
                  height: { lg: "41px", xs: "30px", sm: "33px", md: "35px" },
                  "&:hover": {
                    backgroundColor: "rgba(255, 102, 51, 0.9)",
                  },
                }}
              >
                View All
              </Button>
            </Link>
          )}
        </Box>
      </Box>

      <Box className="App_product" sx={{ position: 'relative' }}>

        <Grid
          container
          spacing={2}
          ref={sliderRef}
          sx={{
            display: "flex",
            flexWrap: { xs: 'nowrap', sm: 'wrap' }, // Only nowrap on mobile
            overflowX: { xs: "auto", lg: "hidden" },
            overflowY: "hidden",
            scrollBehavior: "smooth",
            transition: "scroll 0.3s ease-in-out",
            px: 1,
            pb: 2,
            '&::-webkit-scrollbar': {
              display: 'none'
            },
          }}
        >
          {(isLoading ? Array(brand_count).fill(null) : brands)?.map((item, index) => (
            <Grid item xs={6} sm={4} md={3} lg={2.4} key={isLoading ? index : item.id}>
              <BrandCard
                item={item}
                onClick={() => handleClick(item)}
                isLoading={isLoading}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

const features = [
  {
    id: '01',
    title: 'Genuine Parts',
    description: 'At AutoDukan, we recognize the paramount significance of quality and reliability in the realm of vehicle maintenance and enhancement.',
    image: parts
  },
  {
    id: '02',
    title: 'Maximum Availability',
    description: 'At Autodukan, we guarante maximum availability of products. Shop with confidence, we have everything you need, whenever you need it.',
    image: availability
  },
  {
    id: '03',
    title: 'Best Rates',
    description: 'At Autodukan, we offer the best rates on all products. Enjoy unbeatable prices without compromising quality. Your satisfaction is our commitment.',
    image: rates
  },
  {
    id: '04',
    title: 'On Time Delivery',
    description: 'At Autodukan, we provide the fastest delivery. Receive your orders promptly, ensuring you get what you need when you need it.',
    image: delivery
  }
];

const GradientBackground = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(135deg, #ff6633 0%, #003399 100%)',
  padding: theme.spacing(8, 0),
  minHeight: '400px',
  display: 'flex',
  alignItems: 'center',
}));

const FeatureItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  background: 'rgba(255, 255, 255, 0.2)',
  borderRadius: '50%',
  padding: theme.spacing(1.5),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StatsCard = styled(Paper)(({ theme }) => ({
  position: 'absolute',
  bottom: -20,
  right: -20,
  background: '#003399',
  color: 'white',
  padding: theme.spacing(2),
  borderRadius: theme.spacing(2),
  textAlign: 'center',
}));

const ImageContainer = styled(Paper)(({ theme }) => ({
  position: 'relative',
  background: 'rgba(255, 255, 255, 0.1)',
  backdropFilter: 'blur(8px)',
  borderRadius: theme.spacing(4),
  padding: theme.spacing(3),
  transform: 'rotate(0deg)',
  transition: 'transform 0.3s ease',
  '&:hover': {
    transform: 'rotate(3deg)',
  },
}));

export const HomeSection4 = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const loggedIn = localStorage.getItem("is_login");
  const [recentllyViewed, setRecentllyViewed] = useState([]);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const isMobile1 = useMediaQuery(theme.breakpoints.down('md'));

  const isLargeScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const isXsScreen = useMediaQuery(theme.breakpoints.down("xs"));
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md"));

  const sliderRef1 = useRef(null);
  const scrollAmount1 = 300;

  const sliderRef2 = useRef(null);
  const scrollAmount2 = 300;

  const [brands, setBrands] = useState({ oemData: [], oesData: [] });

  const { selectedCar, fetchSelectedCar } = useSelectedCar();

  let brand_count = 10;

  if (isXsScreen) {
    brand_count = 9;
  }
  if (isSmallScreen && !isXsScreen) {
    brand_count = 8;
  }
  if (isMediumScreen && !isSmallScreen) {
    brand_count = 9;
  }
  if (isLargeScreen && !isMediumScreen) {
    brand_count = 12;
  }

  const getAllBrands = async () => {
    try {

      const res = await getCarBrands();
      if (res.code === 200 && Array.isArray(res.data)) {
        setBrands({
          oemData: res.data.filter((brand) => brand.oem === 1).slice(0, brand_count),
          oesData: res.data.filter((brand) => brand.oem === 0).slice(0, brand_count),
        });
        setIsLoading(false);
      } else {
        setBrands({ oemData: [], oesData: [] });
      }
    } catch (error) {
      console.error("Error fetching car brands:", error);
      setBrands({ oemData: [], oesData: [] });
    }
  };


  useEffect(() => {
    getAllBrands();
    if (loggedIn) {
      RecentllyViewed();
    }
  }, []);

  const RecentllyViewed = async () => {
    if (loggedIn) {
      const response1 = await getRecentllyViewed(1);
      setRecentllyViewed(response1?.data);
    }
  };

  const handleClick = (data) => {
    if (loggedIn) {
      if (data?.id === selectedCar?.brand_id) {
        setOpenDialog(true);
        setSelectedBrand(data);
      } else {
        navigate(`/car-select?brand_id=${data?.id}`, {
          state: {
            cat_name: data?.name,
          },
        });
      }
    }
    else {
      navigate(`/car-select?brand_id=${data?.id}`)
    }
  };

  const handleClick2 = (data) => {
    navigate({
      pathname: `/products-list`,
      search: `?car_model_id=${selectedCar.compatibility_group_id}&page=1`,
      state: {
        cat_name: data?.name,
      },
    });
  };

  const handleClickoes = (data) => {
    if (!loggedIn) {
      navigate({
        pathname: `products-list`,
        search: `?brand_name=${data?.slug}`,
      });
    } else {
      if (selectedCar && selectedCar == "") {
        navigate({
          pathname: `products-list`,
          search: `?brand_name=${data?.slug}&page=1`,
        });
      } else {
        navigate({
          pathname: `products-list`,
          search: `?brand_name=${data?.slug}&car_model_id=${selectedCar?.compatibility_group_id}&page=1`,
        });
        // navigate(`/Oes-shop/${selectedCar?.compatibility_group_id}/${data?.slug}/${1}`, {
        //   state: {
        //     cat_name: data?.name,
        //   },
        // });
      }
    }
  };


  const handleClickProduct = (data) => {

    const nav = data.slug !== null ? data.slug : data.id;
    window.open(`/product/${nav}`, '_blank');

  };


  const anotherCar = () => {
    navigate(`/add-car`, {
    });
  }

  return (
    <>
      <Grid
        fluid="true"
        maxWidth={{ xl: "1303px", lg: "1103px", xs: undefined, md: "900px", sm: "800px" }}
        margin="auto"
        sx={{
          padding: { lg: "0px", md: "0px", sm: "10px", xs: "10px" }
        }}
      >
        <Box sx={{ my: 8 }}>
          {/* OEM Brands Section */}
          <BrandsSection
            title="Popular OEM Brands"
            brands={brands?.oemData}
            onViewAll={{ pathname: "/brands", search: "?brand=OEM" }}
            handleClick={handleClick}
            sliderRef={sliderRef1}
            isLoading={isLoading}
            brand_count={brand_count}
          />

          {/* OES Brands Section */}
          <BrandsSection
            title="Popular OES Brands"
            brands={brands?.oesData}
            onViewAll={{ pathname: "/brands", search: "?brand=OES" }}
            handleClick={handleClickoes}
            sliderRef={sliderRef2}
            isLoading={isLoading}
            brand_count={brand_count}
          />
        </Box>

        <Box
          component="section"
          sx={{
            // py: { xs: 6, md: 8, lg: 10 },
            py: { xs: 6, md: 7, lg: 5 },
            // px: { xs: 2, sm: 3, md: 4 }
          }}
        >
          {/* Section Header */}
          <Typography
            component="h2"
            className="title_name1"
            sx={{
              textAlign: "center",
              fontSize: { xs: '28px', md: '32px', lg: '35px' },
              textTransform: "uppercase",
              fontWeight: 500,
              lineHeight: 1.2,
              fontFamily: "'Bebas Neue', sans-serif",
              mb: { xs: 4, md: 6, lg: 8 }
            }}
          >
            Why Choose Us
          </Typography>

          {/* Features Grid */}
          <Grid
            container
            spacing={{ xs: 2, sm: 3, md: 4, lg: 2 }}
            sx={{ maxWidth: 'xl', mx: 'auto' }}
          >
            {features.map((feature) => (
              <Grid item xs={12} sm={6} md={6} lg={3} key={feature.id}>
                <Card
                  variant="outlined"
                  sx={{
                    height: '100%',
                    borderRadius: '10px',
                    transition: 'all 0.3s ease',
                    // '&:hover': {
                    //   transform: 'translateY(-4px)',
                    //   boxShadow: (theme) => theme.shadows[4],
                    //   borderColor: 'rgba(255, 102, 51, 0.5)'
                    // }
                  }}
                >
                  <Box
                    sx={{
                      position: 'relative',
                      p: 2,
                      height: { xs: 100, sm: 100 },
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    {/* Feature Image */}
                    <CardMedia
                      component="img"
                      image={feature.image}
                      alt={feature.title}
                      loading="lazy"
                      sx={{
                        height: { xs: 80, sm: 100 },
                        width: 'auto',
                        objectFit: 'contain'
                      }}
                    />

                    {/* Feature Number */}
                    <Typography
                      variant="h6"
                      sx={{
                        position: 'absolute',
                        top: 6,
                        right: 22,
                        color: '#76757530',
                        fontWeight: 500,
                        fontSize: { xs: '48px', sm: '60px' },
                        lineHeight: 1.2,
                        fontFamily: "'Bebas Neue', sans-serif",
                        textTransform: 'uppercase'
                      }}
                    >
                      {feature.id}
                    </Typography>
                  </Box>

                  <CardContent sx={{ pt: 2 }}>
                    {/* Feature Title */}
                    <Typography
                      gutterBottom
                      variant="h5"
                      sx={{
                        fontSize: { xs: '18px', sm: '20px' },
                        textTransform: 'uppercase',
                        fontWeight: 500,
                        lineHeight: 1.2,
                        fontFamily: "'Bebas Neue', sans-serif",
                        color: 'rgba(255, 102, 51, 1)',
                        mb: 1
                      }}
                    >
                      {feature.title}
                    </Typography>

                    {/* Feature Description */}
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{
                        fontSize: { xs: '13px', sm: '14px' },
                        lineHeight: 1.5
                      }}
                    >
                      {feature.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>



        {loggedIn && recentllyViewed !== null && recentllyViewed.length > 0 && (
          <Box
            justifyContent={"center"}
            alignContent={"center"}
            sx={{
              // padding: { lg:  "18px 121px 41px 125px",  md: "45px 56px 100px 56px", xs: "20px" },
              // [theme.breakpoints.down('xs')]: {
              //   padding: 0,
              // },
              marginTop: { lg: "94px", xs: "50px" },
              mb: { lg: "80px", xs: "50px" }
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  fontSize: { lg: "35px", xs: "28px" },
                  textTransform: "uppercase",
                  borderRadius: "10px",
                  fontWeight: 500,
                  lineHeight: "30px",
                  fontFamily: "'Bebas Neue', sans-serif"
                }}
                id="recently"
              >
                Recentlly Viewed
              </Typography>
            </Box>
            <Recentlyviwed
              handleClick={handleClickProduct}
            />
          </Box>

        )}

        <Grid
          justifyContent={"center"}
          alignContent={"center"}
          sx={{
            padding: { lg: "0px 50px 50px 50px", xs: '0px', md: "0px 30px 30px 30px" },
            mb: "35px"
          }}
        >
          <Box sx={{
            display: "flex",
            flexGrow: 1,
            position: "relative",
            justifyContent: "center",
            alignItems: "center",
          }}>
            <Box
              display={"flex"}
              sx={{
                width: { lg: "1000px", xs: "100%" },
                height: "auto",
              }}
            >
              <img
                loading="lazy"
                src={isMobile ? mobile_design2 : mobile_design}
                style={{
                  height: isMobile ? "100%" : "100%",
                  width: isMobile ? "100%" : "100%", objectFit: "cover"
                }}
                alt="" />
            </Box>
            {isMobile ? (
              <Box zIndex={1} position="absolute" top="54%" transform="translate(50%, -50%)" display={"flex"} flexDirection={"column"}>
                <Box>
                  <h1
                    style={{
                      fontSize: "12vw", // Using viewport width units for font size
                      textAlign: "center",
                      fontWeight: 500,
                      fontFamily: "'Bebas Neue', sans-serif",
                      color: "#FF6633",
                      flexWrap: "wrap",
                      whiteSpace: "pre-wrap", // Add this line
                      margin: "0px",
                    }}
                  >
                    Download
                    {"\n"}
                    AutoDukan App
                  </h1>

                  {/* <Typography
                      sx={{
                        fontSize: { lg: "6vw", xs: "13vw" },
                        textAlign: "center",
                        fontWeight: 500,
                        lineHeight: { lg: "1", xs: "1.2" },
                        fontFamily: "'Bebas Neue', sans-serif",
                        color: "#FF6633"
                      }}
                    >
                      AutoDukan App
                    </Typography> */}
                  <Box sx={{ marginTop: "8px", width: "80vw", padding: "1.5vw" }}> {/* Using viewport width units for width and padding */}
                    <Typography
                      sx={{
                        textAlign: "center",
                        fontSize: { lg: "1.5vw", xs: "5vw" }, // Adjusting font size for smaller screens
                        fontFamily: "'Barlow', sans-serif",
                        fontWeight: 600,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "normal",
                      }}
                    >
                      Choose and book a seamless car service experience and get exciting offers with the Autodukan App
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        width: "150px",
                        mt: 2,
                      }}
                    >
                      <a href="https://play.google.com/store/apps/details?id=com.pragunservices.autodukan" target="_blank" rel="noopener noreferrer">
                        <img
                          loading="lazy"
                          src={google_playstore}
                          alt="play_store_img" width={"100%"}
                          objectFit={"contain"}
                        />
                      </a>
                    </Box>
                  </Box>
                </Box>
              </Box>
            ) : (
              <Box position="absolute" top={{ lg: "28%", sm: "25%", md: "30%" }} right={{ xl: "13%", lg: "4%", md: "5%", sm: "3%" }} transform="translate(50%, -50%)" zIndex={1} p={2}>
                <Box display={"flex"} flexDirection={"column"}>
                  <Box>
                    <h1
                      className="download"
                      style={{
                        fontSize: { lg: "53px", md: "47px", xs: "20px", sm: "30px" },
                        textTransform: "uppercase",
                        textAlign: "center",
                        fontWeight: 500,
                        lineHeight: "30px",
                        fontFamily: "'Bebas Neue', sans-serif",
                        color: "#FF6633",
                        margin: "0px",
                      }}
                    >
                      Download AutoDukan App
                    </h1>
                    <Box sx={{ marginTop: { lg: "23px", md: "18px", sm: "15px" } }}>
                      <Typography
                        className="download_content"
                        sx={{
                          fontSize: { lg: "22px" },
                          textAlign: "center",
                          fontFamily: "'Barlow', sans-serif",
                          fontWeight: 600,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Choose and book a seamless car service experience
                      </Typography>
                      <Typography
                        className="download_content"
                        sx={{
                          fontSize: { lg: "22px" },
                          textAlign: "center",
                          fontWeight: 600,
                          fontFamily: "'Barlow', sans-serif",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        and also get exciting offers with the Autodukan App
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: { lg: "150px", sm: "120px", md: "150px" },
                          mt: 2,
                        }}
                      >
                        <a href="https://play.google.com/store/apps/details?id=com.pragunservices.autodukan" target="_blank" rel="noopener noreferrer">
                          <img
                            loading="lazy"
                            src={google_playstore}
                            alt="play_store_img"
                            width={"100%"}
                            objectFit={"contain"}
                          />
                        </a>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
        </Grid>

        <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
          <DialogTitle>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                fontSize: "20px",
              }}
            >
              <Typography sx={{ textAlign: "left", fontSize: "1.4rem", fontWeight: 600 }}>Selected Car Brand Found</Typography>
              <IconButton onClick={() => setOpenDialog(false)}>
                <CloseIcon sx={{ fontSize: 30 }} />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent>
            <Typography
              color={"#000"}
              fontWeight={500}
            >
              The OEM Brand <span style={{ color: "#FF6633", fontWeight: 600 }}>{selectedBrand?.name}</span> matches your Selected Car Brand, do you want to proceed to Part Search or add another car to your garage?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Box sx={{
              display: "flex",
              flex: 1,
              alignItems: "center",
              justifyContent: "center",
              // fontSize: "50px",
              paddingX: "20px",
            }}
            >
              <Grid container gap={1} display={"flex"} justifyContent={"space-between"}>
                <Grid item lg={5} md={5} xs={12} sm={12} >
                  <Button
                    variant="contained"
                    fullWidth
                    sx={{
                      backgroundColor: "#FF6633",
                      whiteSpace: "nowrap",
                      "&:hover": {
                        backgroundColor: "#000",
                        color: "#fff",
                      },
                    }}
                    onClick={() => {
                      anotherCar();
                    }}
                  >
                    Add Another Car
                  </Button>
                </Grid>
                <Grid item lg={5} md={5} xs={12} sm={12} >
                  <Button
                    variant="contained"
                    fullWidth
                    sx={{
                      backgroundColor: "#FF6633",
                      whiteSpace: "nowrap",
                      "&:hover": {
                        backgroundColor: "#000",
                        color: "#fff",
                      },
                    }}
                    onClick={() => {
                      handleClick2(selectedBrand)
                    }}
                  >
                    Proceed to Search
                  </Button>
                </Grid>
              </Grid>

            </Box>
            {/* <Button onClick={() => setOpenDialog(false)} color="primary">
            Close
          </Button> */}
          </DialogActions>
        </Dialog>
      </Grid >
      <GradientBackground>
        <Container alignContent="center" justifyContent="space-evenly">
          <Grid container alignItems="center" justifyContent="space-evenly">
            {/* Left Content Section */}
            <Grid item xs={12} sm={6}>
              <Box color="white">
                <Typography variant="h2" component="h1" gutterBottom fontWeight="bold">
                  Become a Seller at AutoDukan
                </Typography>

                <Typography variant="h6" sx={{ mb: 4, opacity: 0.9 }}>
                  Join our growing marketplace and reach thousands of customers.
                  Start your selling journey today!
                </Typography>

                <Box sx={{ mb: 4 }}>
                  <FeatureItem>
                    <IconWrapper>
                      <MonetizationOnOutlinedIcon sx={{ color: 'white' }} />
                    </IconWrapper>
                    <Typography variant="h4">Earn more with competitive incentives</Typography>
                  </FeatureItem>

                  <FeatureItem>
                    <IconWrapper>
                      <GroupsOutlinedIcon sx={{ color: 'white' }} />
                    </IconWrapper>
                    <Typography variant="h4">Reach thousands of customers</Typography>
                  </FeatureItem>

                  <FeatureItem>
                    <IconWrapper>
                      <RocketLaunchOutlinedIcon sx={{ color: 'white' }} />
                    </IconWrapper>
                    <Typography variant="h4">Easy to start selling</Typography>
                  </FeatureItem>
                </Box>

                <Button
                  variant="contained"
                  size="large"
                  endIcon={<ArrowForwardIcon />}
                  onClick={() => navigate('/seller')}
                  sx={{
                    bgcolor: 'white',
                    color: '#003399',
                    px: 4,
                    py: 2,
                    borderRadius: '50px',
                    '&:hover': {
                      bgcolor: 'rgba(255, 255, 255, 0.9)',
                    },
                  }}
                >
                  Start Selling Now
                </Button>
              </Box>
            </Grid>

            {/* Right Image Section */}
            <Grid item xs={12} sm={6} display={{ xs: 'none', sm: 'block' }}>
              <Box position="relative" sx={{ maxWidth: { md: 400, xs: 300 }, mx: 'auto' }}>
                <ImageContainer elevation={3}>
                  <img
                    src={benifits4}
                    alt="Seller Dashboard Preview"
                    style={{
                      width: '100%',
                      height: 'auto',
                      borderRadius: theme.spacing(2),
                    }}
                  />
                </ImageContainer>

                <StatsCard elevation={4}>
                  <Typography variant="h3" component="div" fontWeight="bold">
                    1000+
                  </Typography>
                  <Typography variant="subtitle1" sx={{ opacity: 0.8 }}>
                    Active Sellers
                  </Typography>
                </StatsCard>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </GradientBackground>
    </>
  );
};

export default HomeSection4;
